import z from "zod"

export const BackofficeScheduledReportSchema = z.object({
  id: z.bigint().transform(String),
  alias: z.string(),
  frequency: z.string(),
  isActive: z.boolean(),
  createdAt: z.date().transform((value) => value.toISOString()),
  updatedAt: z.date().transform((value) => value.toISOString()),
  lastRunAt: z
    .date()
    .nullish()
    .transform((value) => value?.toISOString()),
  lastDurationMs: z.number().nullable(),
  lastFailedAt: z
    .date()
    .nullable()
    .transform((value) => value?.toISOString() ?? null),
  lastFailedReason: z.string().nullable(),
  spreadsheetId: z.string(),
  cell: z.string(),
  query: z.string(),
  useFloatComma: z.boolean(),
})

export const BackofficeScheduledReportErrorResponseData = z.object({
  error: z.string().nullable(),
})

export const BackofficeScheduledReportUpsertResponseData = z.union([
  BackofficeScheduledReportErrorResponseData,
  BackofficeScheduledReportSchema,
])

export const BackofficeScheduledReportsResponseDataSchema = z.array(BackofficeScheduledReportSchema)

export const BackofficeScheduledReportEnqueueResponseDataSchema = z.object({
  success: z.boolean(),
})
